module.exports = __webpack_public_path__ + "img/seatselection_wringlyfield.d1307747.svg";